module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "section1"
    }
  }, [_c('transition', {
    attrs: {
      "name": "modal",
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$mq === 'mobilep' || _vm.$mq === 'tabletp'),
      expression: "$mq === 'mobilep' || $mq === 'tabletp'"
    }],
    staticClass: "mobile-modal"
  }, [_c('div', {
    staticClass: "mainbox"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(this.$store.state.items.portraitAlert)
    }
  }), _vm._v(" "), _c('p', [_c('i', {
    staticClass: "fas fa-2x fa-redo"
  })])])])]), _vm._v(" "), (_vm.location === 1) ? _c('page1') : _vm._e(), _vm._v(" "), (_vm.location === 2) ? _c('page2') : _vm._e(), _vm._v(" "), (_vm.location === 3) ? _c('page3') : _vm._e(), _vm._v(" "), (_vm.location === 4) ? _c('page4') : _vm._e(), _vm._v(" "), (_vm.location === 5) ? _c('page6') : _vm._e(), _vm._v(" "), (_vm.location === 6) ? _c('page7') : _vm._e(), _vm._v(" "), _c('button-back'), _vm._v(" "), _c('button-next')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-87f2a3aa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/section1/Section1.vue
// module id = 146
// module chunks = 0